import { BaseListIconColumnProps } from '../types';

/**
 * @internal
 */
export const getCellIcon = (column: BaseListIconColumnProps, rowIndex: number) =>
  typeof column.cellIcon === 'function' ? column.cellIcon(rowIndex) : column.cellIcon;

/**
 * @internal
 */
export const getCellHelpPopup = (column: BaseListIconColumnProps, rowIndex: number) =>
  typeof column.cellHelpPopup === 'function'
    ? column.cellHelpPopup(rowIndex)
    : column.cellHelpPopup;
